import { Link, useLocation } from "react-router-dom";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/blog", label: "Articles" },
  { to: "/heatmap", label: "Heatmap" },
  { to: "/research", label: "Research" },
  { to: "/about", label: "About" },
];

const MobileMenu = ({ isOpen, onClose }: MobileMenuProps) => {
  const location = useLocation();

  if (!isOpen) return null;

  return (
    <div className="sm:hidden border-t border-border bg-background/95 backdrop-blur-md">
      <div className="px-3 py-3 space-y-1">
        {navLinks.map((link) => {
          const isActive = location.pathname === link.to ||
            (link.to !== "/" && location.pathname.startsWith(link.to));

          return (
            <Link
              key={link.to}
              to={link.to}
              className={`block px-3 py-2.5 rounded-md text-base font-medium transition-colors ${
                isActive
                  ? "text-accent bg-secondary"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
              }`}
              onClick={onClose}
            >
              {link.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileMenu;
